import React from 'react';
import { useFormContext } from 'react-hook-form';
import { mapToOption } from '../../../../utlis';
import PhoneInput from './PhoneInput';

const ContactDetailsForm = ({ relations, apiFieldErrors }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  // Helper function to get error border class
  const getErrorBorderClass = (fieldName) => {
    return errors[fieldName] || apiFieldErrors?.[fieldName]
      ? 'border-danger-500'
      : 'border-secondary-500';
  };

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        <div className="flex flex-col w-full">
          <label htmlFor="contactName" className="text-text-hint mb-1">
            Contact's Name<span className="text-danger-500">*</span>
          </label>
          <input
            {...register('contactName', {
              required: 'Contact name is required',
            })}
            type="text"
            placeholder="Contact Name"
            className={`outline-none border-2 ${getErrorBorderClass('contactName')} rounded-lg text-black pencialicon`}
          />
          {errors.contactName && (
            <span className="text-danger-500">{errors.contactName.message}</span>
          )}
        </div>

        <PhoneInput name="contactPhoneNum" label="Contact's Phone Number" required={true} hasApiError={!!apiFieldErrors?.contactPhoneNum} />

        <div className="flex flex-col w-full">
          <label htmlFor="contactEmail" className="text-text-hint mb-1">
            Contact's Email ID<span className="text-danger-500">*</span>
          </label>
          <input
            {...register('contactEmail', {
              required: 'Contact Email is required',
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: 'Please enter a valid email address',
              },
            })}
            type="email"
            className={`outline-none border-2 ${getErrorBorderClass('contactEmail')} rounded-lg text-black pencialicon`}
          />
          {errors.contactEmail && (
            <span className="text-danger-500">{errors.contactEmail.message}</span>
          )}
        </div>

        <div className="flex flex-col w-full max-w-md">
          <label htmlFor="contactRelation" className="text-text-hint mb-1">
            Contact's Relation<span className="text-danger-500">*</span>
          </label>
          <select
            {...register('contactRelation', {
              required: 'Contact Relation is required',
            })}
            className="outline-none border-2 border-secondary-500 rounded-lg text-black dropdown"
          >
            {mapToOption(relations?.relation || [], 'type').map((option, index) => (
              <option key={`${option.value}-${index}`} value={option.value}>
                {option.text}
              </option>
            ))}
          </select>
          {errors.contactRelation && (
            <span className="text-danger-500">{errors.contactRelation.message}</span>
          )}
        </div>
      </div>
    </>
  );
};

export default ContactDetailsForm;
